import React from 'react'
import Card from '../Card/Card';
import HorizontalBar from '../HorizontalBar/HorizontalBar';
// import snakegameimage from '../../../../assets/images/snake-game.png';
// import todaylistimage from '../../../../assets/images/today-list.png';

import classes from './Projects.module.css'

const projectData = [
  {
    name: 'Today List',
    link: `https://todaylist.carrd.co/`,
    description: 'Slack application built using NodeJS',
    // image: todaylistimage,
    imagealt: 'Today List',
    features: [
      {
        heading: 'Product Hunt',
        link: 'https://www.producthunt.com/posts/today-list-1',
        details: 'Voted among top 10 products on the launch date'
      },
      {
        heading: 'Lifehacker',
        link:
          'https://lifehacker.com/create-daily-to-do-lists-within-slack-with-today-list-1829894653',
        details: 'How to Create Daily To-Do Lists Within Slack'
      }
    ]
  },
  {
    name: 'TwoFacts',
    imagealt: 'TwoFacts',
    link: `https://github.com/rajat-sr/twofacts`,
    description: 'Two-factor authentication for Node.js using Google Authenticator.'
  },
  {
    name: 'React Code Card',
    imagealt: 'React Code Card',
    link: `https://github.com/rajat-sr/react-code-card`,
    description: 'React component to display code snippets, like Stripe.'
  },
  {
    name: 'Scryptonian',
    imagealt: 'Scryptonian',
    link: `https://issuetracker-scryptonians.netlify.com/`,
    description: 'An open-source Kanban based issue tracker, similar to Trello',
    features: [
      {
        heading: 'Github',
        link: 'https://github.com/pesto-students/batch-7-Scryptonian',
        details: 'Built using ReactJS, NodeJS, MongoDB'
      }
    ]
  },
  {
    name: 'Snake Game',
    // image: snakegameimage,
    imagealt: 'Classic Snake Game',
    link: `https://rajat-sr.github.io/snake-game/`,
    description: 'Complete React-based game'
  }
]

const projectList = projectData.map((project, index) => (
  <div key={project.link}>
    {index === 0 ? null : <HorizontalBar />}
    <a href={project.link} target="_blank" rel="noopener noreferrer">
      <h2 className={classes.Title}>{project.name}</h2>
    </a>
    <p>{project.description}</p>
    {project.features ? (
      <div style={{ marginTop: '25px' }}>
        {project.features.map(projectFeature => (
          <div className={classes.ProjectFeature} key={projectFeature.link}>
            <a href={projectFeature.link} target="_blank" rel="noopener noreferrer">
              <h5>{projectFeature.heading}</h5>
            </a>
            <p>{projectFeature.details}</p>
          </div>
        ))}
      </div>
    ) : null}
  </div>
));



const Projects = (props) => {

  return (
    <Card eventTypes="click" goBack={props.history.goBack}>
      <h1>Projects</h1>
      <ul className={classes.Projects}>{projectList}</ul>
    </Card>
  );
}

export default Projects